import { NextPage } from "next"
import { ManualReconciliation } from "src/features/reconciliations/components/ManualReconciliation"
import Head from "next/head"
import { Heading, Link } from "@smooth/design-system-components"
import { DefaultLayout } from "src/components/Layout"

const BACK = { href: "/admin/reconciliations", label: "消し込み一覧へ" }

const ManualReconciliationPage: NextPage = () => (
  <DefaultLayout>
    <Head>
      <title>消し込みページ | for Smoother</title>
    </Head>
    <div style={{ height: "calc(100vh - 90px)", overflowY: "auto" }}>
      <div data-smooth-ds className="mx-auto max-w-[900px] px-4 py-6 sm:px-6 lg:px-8">
        <div className="mb-6 flex flex-col gap-2">
          <Link href={BACK.href}>{BACK.label}</Link>
          <Heading level={1}>消し込みページ</Heading>
        </div>
        <ManualReconciliation />
      </div>
    </div>
  </DefaultLayout>
)

export default ManualReconciliationPage
